import React from "react";
import LookingForMoreLinks from "./LookingForMoreLinks";

class ExploreMoreLinks extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {

        }
    }

    getInvoiceLink = () => {
    	let invoiceLink = "https://" + this.props.siteConfigData.domainName + "/invoiceredirect.do?bn=" + this.props.booking.bookingNumber + "&cn=" + this.props.booking.bookingSummary.guestList[0].customerNumber + "&cs=" + this.props.booking.encryptedKey + "&bp=" + this.props.booking.bookingSummary.charges.totalCost + "&bd=" + this.props.booking.bookingDate;
    	return invoiceLink;
    }

    getShoreExcursionsLink = () => {
    	let invoiceLink = "http://www.shoreexcursionsgroup.com/v/affiliate/?id=" + this.props.getSitePropertyValue('SHORE_EXCURSIONS_ID');
    	return invoiceLink;
    }

    formatDate = (date) => {
    	let dd = String(date.getDate()).padStart(2, '0');
    	let mm = String(date.getMonth() + 1).padStart(2, '0');
    	let yyyy = date.getFullYear();
    	return yyyy + '-' + mm + '-' + dd;
    }

    displayBookAnotherStateroomButtton = () => {
    	let currentDate = new Date();
    	currentDate = new Date(currentDate.setHours(0, 0, 0, 0));
    	currentDate = this.formatDate(currentDate);
    	return this.props.getSitePropertyValue('CSS_BOOK_ANOTHER_STATEROOM_BUTTON') === 'Y' && this.props.booking.bookingOverview.sailingId !== null && this.props.booking.bookingOverview.sailingId !== 'null' && this.props.booking.bookingOverview.sailingId !== '' && this.props.booking.bookingOverview.bookableOnline === true && this.props.booking.bookingOverview.departureDate >= currentDate;
    }

    getExploreDiscountedAddonLink = () => {
		let baseUrl = this.props.siteConfigData.domainName.replace(/^www\./, '');
    	let rewardsLink = "https://rewards." + baseUrl + "/dashboard/discounted-add-ons";
    	return rewardsLink;
    }

    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }

    getDomainLink = () => {
    	let domainLink = "https://" + this.props.siteConfigData.domainName + "/promotion/cruise-transfers.do"; 
    	return domainLink;
    }

	getNextBookingPromoLink = () => {
    	let nextBookingPromoLink = "https://" + this.props.siteConfigData.domainName + "/promotion/book-your-next-cruise.do?cid=" + this.getSitePropertyValue("CSS_CID_PROMOTION_ID");
    	return nextBookingPromoLink;
    }

	getTravelHotelLink = () => {
    	let travelHotelLink = "https://travel.bjs.com/hotels/";
    	return travelHotelLink;
    }

	getBookLightLink = () => {
    	const bookFlightLink = `https://www.aadvantagecruises.com/aaports.do?port=${this.props.booking.bookingOverview.departurePortCode}`;
    	return bookFlightLink;
    }
    
    getSailingLink = () => {
    	let sailingId = this.props.booking.bookingOverview.sailingId;
    	let nextSailingLink = "https://" + this.props.siteConfigData.domainName + "/b/c/sail.do?sailingId=" + sailingId;
    	return nextSailingLink;
    }

    getCruisePackingListLink = () => {
    	let regionCode = this.props.booking.bookingOverview.regionCode;
    	let destination = "";
    	switch(regionCode) {
    		case "ALSK":
    			destination = "alaska-cruise-packing-list.do";
    			break;
    		case "MECA":
    			destination = "caribbean-cruise-packing-list.do";
    			break;
    		case "CARI":
    			destination = "caribbean-cruise-packing-list.do";
    			break;
    		case "NAMR":
    			destination = "canada-new-england-cruise-packing-list.do";
    			break;
    		case "MEDT":
    			destination = "mediterranean-cruise-packing-list.do";
    			break;
    		case "EURO":
    			destination = "northern-europe-cruise-packing-list.do";
    			break;
			default:
				break;
    	}
    	let cruisePackingListLink = "https://" + this.props.siteConfigData.domainName + "/promotion/" + destination;
    	window.open(cruisePackingListLink,'_blank', "");
    }

    getRedeemableBonusOffers = (booking, hash) => {
    	this.props.ajaxSpinnerShow();
        console.debug('Retrieve bonus offers...');
        let url = '/wthrest/customer-self-service/retrieveRedeemableBonusOffers.rs';
        let payload = {
            "bookingNumber": this.props.booking.bookingNumber
        };
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(retrieveBonusOfferResponse => retrieveBonusOfferResponse.json()).then(jsonBonusOfferResponse => {

        	if(jsonBonusOfferResponse===''||jsonBonusOfferResponse===null) {
        		this.props.ajaxSpinnerHide();
                let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
               	 this.props.CallTracker("Customer Self Service", "Errors", "Non-cruise booking");
               	 this.setState({
                        'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                    });
                this.setState({accessReservationBookingDisabled: false});
            } else {            
            //show new view
            this.props.ajaxSpinnerHide();
            this.props.onChangeViewRedeem(this.props.booking, this.props.booking.hash, jsonBonusOfferResponse, this.props.updateBooking);
            }
        }).catch(error => {
        	this.props.ajaxSpinnerHide();
            this.setState({accessReservationBookingDisabled: false});
            this.setState({'showVerificationErrorMessage': true});
            let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
            //TODO  make errors more specific
            this.setState({
                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
            });
        });
    	
    }

    render() {
        
        return (
            <div id="cssSummaryMoreLinksCont" class='wth3-moreLinksContainer'>
                <div class="wth3-moreLinksContainer__explore" id="cssSummaryExplore">
                    <div id="cssSummaryExploreTitleBox" class="wth3-moreLinksContainer__explore-titleBox">
                        <h2 id="cssSummaryExploreTitleHead" class="wth3-moreLinksContainer__explore-titleBox-header">Explore more for your cruise</h2>
                    </div>
                    {this.props.getStoreAttValue('SCB') === 'Y' &&
                    <a href='https://bit.ly/39Ojsby' target="_blank" rel="noopener noreferrer" class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryScheduleCallBack" onClick = {() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Schedule Call Back")} }>
                        Schedule Call Back
                    </a>
                    }
                    <a href={this.getInvoiceLink()} target="_blank" rel="noopener noreferrer" class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryReviewBookConfirm" onClick = {() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Review Your Booking Confirmation")}}>
                        Review Your Booking Confirmation
                    </a>
                    {this.props.updateBooking.bookingSummary.charges.remainingBalance!=='0.0' && this.props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments!==0 && this.props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments >=25 && this.props.apiCruisLines.includes(this.props.updateBooking.bookingOverview.cruise.cruiseLineName) &&
                    <a href="# " class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryMakeSafeSecurePayments" onClick={(e) => {e.preventDefault(); this.props.onChangeView('paymentview', this.props.booking, this.props.booking.hash, this.props.updateBooking)} }>
                        Make Safe and Secure Payments
                    </a>
                    }

                    {this.props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && this.props.updateBooking.insuranceQuote.priceAmount!=='' && this.props.apiCruisLines.includes(this.props.updateBooking.bookingOverview.cruise.cruiseLineName) &&
                        <a href="# " class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryAddTravelInsur" onClick={(e) => {e.preventDefault(); this.props.onChangeView('addinsurance', this.props.booking, this.props.booking.hash, this.props.updateBooking)} }>
                            Add Travel Insurance
                        </a>
                    }            		
                    
                    {this.props.getStoreAttValue('PFB') === 'Y' && this.props.updateBooking.bookingSummary.hasRedeembableBonusOffers === 'Y' &&
                    <a href='# ' class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryRedeemBonusOffer"  onClick={(e) => {e.preventDefault(); this.getRedeemableBonusOffers(this.props.booking, this.props.booking.hash)} }>
                        Redeem Bonus Offer
                    </a>
                    }
                    
                    
                    {this.props.getStoreAttValue('SHF') === 'Y' && this.props.getSitePropertyValue('SHORE_EXCURSIONS_ID')!==null && this.props.getSitePropertyValue('SHORE_EXCURSIONS_ID')!=='' &&
                        <a href={this.getShoreExcursionsLink()} class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryBookShoreExcur" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book Shore Excursions")}}>
                            Book Shore Excursions
                        </a>
                    }

                    {this.props.getStoreAttValue("BMV")!=='' && this.props.getStoreAttValue("BMV")!==null && this.props.getStoreAttValue("BMV")!=='N' &&
                        <a href={this.getExploreDiscountedAddonLink()} class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryExploreDiscountedAddOns" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Explore Discounted Add-ons")}}>
                            Explore Discounted Add-ons
                        </a>
                    }

                    {/* Extra $100 button  */}
                    {this.props.getSitePropertyValue('CSS_BUTTON_$100_OFF_NEXT_BOOKING_PROMO') === 'Y' && this.props.getSitePropertyValue('CSS_CID_PROMOTION_ID') !== null && this.props.getSitePropertyValue('CSS_CID_PROMOTION_ID') !== '' &&
                        <a href={this.getNextBookingPromoLink()} class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryBookPromo" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Claim $100 Off My Next Cruise")}}>
                            Extra $100 off your next booking
                        </a>
                    }	
                    
                    {(this.props.booking.bookingOverview.departurePort?.includes("Seattle") || this.props.booking.bookingOverview.disembarkPort?.includes("Seattle")) && this.props.getSitePropertyValue('CSS_BUTTON_FOR_HOUSE_BRAND')!==null && this.props.getSitePropertyValue('CSS_BUTTON_FOR_HOUSE_BRAND')!=='' && this.props.getSitePropertyValue('CSS_BUTTON_FOR_HOUSE_BRAND')==='Y' &&
                        <a href={this.getDomainLink()} class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryBookPierAirportShuttle" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book My Pier/Airport Shuttle")}}>
                            Book My Pier/Airport Shuttle
                        </a>
                    }
                    {this.getTemplatePropertyValue('BCSS_THINGS_TO_KNOW_FLAG')==='Y' && this.props.updateBooking.bookingOverview.cruise.cruiseLineName==='Carnival Cruise Line' &&       		
                        <a class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryThingToKnow" href="# " rel="nofollow" onClick={() => { this.props.onChangeView('carnivalthings', this.props.booking, this.props.booking.hash, this.props.updateBooking)} }>
                            Things To Know Before You Go
                        </a>	
                    }
                    
                    {this.displayBookAnotherStateroomButtton() && 
                        <a href={this.getSailingLink()} target="_blank" rel="noopener noreferrer" class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryBookAnotherRoom" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book Another Stateroom")}}>
                            Book Another Room On This Cruise
                        </a>
                    }
                    
                    {(this.props.booking.bookingOverview.regionCode === 'MEDT' || this.props.booking.bookingOverview.regionCode === 'CARI' || this.props.booking.bookingOverview.regionCode === 'ALSK' || this.props.booking.bookingOverview.regionCode === 'MECA' || this.props.booking.bookingOverview.regionCode === 'NAMR' || this.props.booking.bookingOverview.regionCode === 'EURO') &&
                        <a href="# " class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryPackChecklist" onClick={(e) => {e.preventDefault(); this.getCruisePackingListLink()}}>
                            Cruise Packing Checklist
                        </a>
                    }
                    {this.props.siteConfigData.store.storeCode === 'BJWEB' &&
                        <a href={this.getTravelHotelLink()} target="_blank" rel="noopener noreferrer" class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryAddHotelStay" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Add a Hotel Stay")}}>
                            Add a Hotel Stay
                        </a>
                    }
                    {this.props.getSitePropertyValue('BOOK_A_FLIGHT_LINK') === 'Y' &&
                        <a href={this.getBookLightLink()} target="_blank" rel="noopener noreferrer" class="wth3-moreLinksContainer__explore-link wth3-link-btn" id="cssSummaryBookFlight" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book a Flight")}}>
                            Book a Flight
                        </a>
                    }
                </div>     
                <LookingForMoreLinks {...this.props} getStoreAttValue={this.props.getStoreAttValue} />  
            </div>
        );
    }
}

export default ExploreMoreLinks;
